/** Ключ обхвата актёра — поле API `users/:id` (целое число в см или null) */
export type TGirthKey =
  | 'chest_girth'
  | 'waist_girth'
  | 'hips_girth'
  | 'neck_girth'
  | 'arm_girth'
  | 'wrist_girth'
  | 'thigh_girth'
  | 'head_girth';

/** Описание обхвата: ключ API, подпись поля и короткая подпись для ряда анкеты */
export interface IActorGirth {
  key: TGirthKey;
  /** Подпись в форме, фильтрах и админке: «Обхват груди» */
  label: string;
  /** Короткая подпись в поповере анкеты: «Грудь» */
  short: string;
}

/**
 * Восемь обхватов актёра. Порядок — контракт с бэком (он же порядок вывода на
 * клиентах), от этого списка строятся ввод, анкета, фильтры и админка
 */
export const ACTOR_GIRTHS: readonly IActorGirth[] = [
  { key: 'chest_girth', label: 'Обхват груди', short: 'Грудь' },
  { key: 'waist_girth', label: 'Обхват талии', short: 'Талия' },
  { key: 'hips_girth', label: 'Обхват бёдер', short: 'Бёдра' },
  { key: 'neck_girth', label: 'Обхват шеи', short: 'Шея' },
  { key: 'arm_girth', label: 'Обхват плеча', short: 'Плечо' },
  { key: 'wrist_girth', label: 'Обхват запястья', short: 'Запястье' },
  { key: 'thigh_girth', label: 'Обхват бедра', short: 'Бедро' },
  { key: 'head_girth', label: 'Обхват головы', short: 'Голова' }
];

/** Ключи обхватов, по которым есть фильтр поиска (грудь, талия, бёдра) */
export const FILTERABLE_GIRTH_KEYS = [
  'chest_girth',
  'waist_girth',
  'hips_girth'
] as const satisfies readonly TGirthKey[];

/** Обхваты с фильтром поиска, в порядке контракта */
export const FILTERABLE_GIRTHS: readonly IActorGirth[] = ACTOR_GIRTHS.filter(
  girth => (FILTERABLE_GIRTH_KEYS as readonly string[]).includes(girth.key)
);

/** Верхняя граница обхвата, см — одна на ввод в профиле (валидация бэка 1..200) и фильтр */
export const GIRTH_MAX = 200;

/**
 * Диапазон фильтра по обхвату по умолчанию, см. Верх — тот же `GIRTH_MAX`: любое значение,
 * которое актёр может сохранить, достижимо фильтром
 */
export const DEFAULT_GIRTH_FILTER_RANGE = [0, GIRTH_MAX];
